import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { switchMap, skip } from 'rxjs/operators';
import { TranslationsLoaderUseCase } from '@/core/domain/translation/usecases/translations-loader.usecase';
import { TranslationsTranslateRoutesUseCase } from '@/core/domain/translation/usecases/translations-translate-routes.usecase';
import { environment as env, environment } from '@/env/environment';
import { UrlService } from '../url/url.service';
import { getLanguage } from '@/common/utils/strings/path.utils';
import { LanguageModel } from '@/core/domain/translation/models/language.model';
import { SsrService } from '../ssr/ssr.service';

@Injectable({
    providedIn: 'root',
})
export class LanguageService {
    currentLanguage = 'es';

    constructor(
        private readonly url: UrlService,
        private readonly transationsLoder: TranslationsLoaderUseCase,
        private readonly translateRoutes: TranslationsTranslateRoutesUseCase,
        private readonly ssr: SsrService,
    ) {}

    public getLanguague(): LanguageModel {
        if (this.ssr.isPlatformServer()) {
            of({ language: 'es' });
        }
        const paths = window.location.href.split('/');
        let currentLanguage = environment.allowedLanguages[0];
        paths.forEach((element) => {
            environment.allowedLanguages.forEach((language) => {
                if (language === element) {
                    currentLanguage = language;
                }
            });
        });
        return { language: currentLanguage as 'es' | 'en' };
    }

    /* onClickChangeLang(toLang: 'es' | 'en'): void {
        if (env.allowedLanguages.includes(toLang)) {
            const regExpValue = env.allowedLanguages.join('|');
            const languagePathRegExp = new RegExp(regExpValue);
            this.translateRoutes.execute().subscribe((responseRealPaths) => {
                responseRealPaths =
                    responseRealPaths.slice(-1) === '/'
                        ? responseRealPaths
                        : responseRealPaths + '/';
                this.transationsLoder
                    .execute({ lang: toLang, reload: false })
                    .pipe(
                        skip(1),
                        switchMap(() =>
                            this.url.format(
                                responseRealPaths.replace(getLanguage(), ''),
                                toLang,
                            ),
                        ),
                    )
                    .subscribe((url) => {
                        if (environment.production) {
                            url = '/' + toLang;
                        }
                        window.location.replace(
                            url.replace(languagePathRegExp, toLang),
                        );
                    });
            });
        }
    } */
}
